<template>
    <div ref="charts" :style="{width:'100%',height:autoHeight}"></div>
</template>
<script>
import Bus from "@/utils/bus";
import echarts from "echarts";
import 'echarts/theme/macarons.js'
export default {
  props: {
    height: {
      type: String,
      default: "200"
    }
  },
  data() {
    return {
      myChart: {},
      screenWidth: document.documentElement.clientWidth,
      screenHeight: document.documentElement.clientHeight,
      resizeTime: null, //节流时间
    };
  },
  methods: {
    refresh(option) {
      this.myChart.hideLoading();
      this.myChart.setOption(option);
      this.$nextTick(()=> {
          Bus.$emit("echarts-resize");
      })

    },
    clearChart(){
        this.myChart.clear();
    },
    initChart(){
      this.myChart = echarts.init(this.$refs.charts, 'macarons');
      this.myChart.showLoading({
        text: '加载中...'
      });
    },
    getWindowSize(){
      window.onresize = ()=>{
          this.screenWidth = document.documentElement.clientWidth;
          this.screenHeight = document.documentElement.clientHeight;
      };
    },
  },
  mounted() {
    this.initChart();
    this.getWindowSize();
    Bus.$on("echarts-resize", () => {
      setTimeout(()=>{
          this.$nextTick(() => {
              console.log("resize");
              this.myChart.resize();
          });
      }, 200)

    });
  },
  watch:{
    screenWidth(){
      if(this.resizeTime){
        clearTimeout(this.resizeTime);
        this.resizeTime = null;
      }
      this.resizeTime = setTimeout(() => {
        Bus.$emit("echarts-resize");
        this.resizeTime = null;
      }, 32)

    },
    screenHeight(){
        if(this.resizeTime){
            clearTimeout(this.resizeTime);
            this.resizeTime = null;
        }
        this.resizeTime = setTimeout(() => {
            Bus.$emit("echarts-resize");
            this.resizeTime = null;
        }, 32)
    }
  },
  computed:{
    autoHeight(){
      if(this.height.indexOf("%") !== -1){
        return this.height;
      } else {
        return this.height + 'px';
      }

    }
  }
};
</script>
